// Copyright © 2021 Move Closer

import { Component } from 'vue-property-decorator'

import { BootstrapButton, BootstrapInput, BootstrapCheck } from '../../dsl/front'

import { AbstractModuleUi } from '../_abstract/ui'
import { ModuleHeaderUi } from '../_components/ui'

import { NewsletterModule } from './Newsletter.contracts'
import { WelcomeFormConfig } from '../../services'

interface NewsletterFormData {
  email: string|null;
  newsletter: boolean|null;
}

/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
@Component<NewsletterModuleUi>({
  name: 'NewsletterModuleUi',
  components: { BootstrapButton, BootstrapInput, BootstrapCheck, ModuleHeaderUi },

  created () {
    this.welcomeConfig = (this.siteService && this.siteService.getWelcomeFormConfig()) || {}
  },

  template: `
    <section class="newsletter-module text-center">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-md-10">
            <div class="newsletter-module__inner">

              <!-- Heading -->
              <ModuleHeaderUi v-if="module.content.header" :header="module.content.header" />
              <!-- Error -->
              <p v-if="this.error" class="text-center text-danger">{{ $t('modules.Newsletter.error') }}</p>
              <!-- Form -->
              <form class="row justify-content-center" @submit.prevent="submitForm">
                <div class="col-12 col-md-9">
                  <!-- E-mail address -->
                  <BootstrapInput type="email" name="email" :model.sync="formData.email"
                                  autocomplete="email" :required="true"
                                  :label="$t('_.email-address')" class="mb-5" />

                  <!-- Newsletter checkbox -->
                  <div class="text-start mb-5">
                    <BootstrapCheck name="newsletter" :model.sync="formData.newsletter"
                                    :options="[{
                                    label: newsletterText,
                                    value: true,
                                    readMore: true
                                  }]" :multiple="true" :required="true" />
                  </div>

                  <p v-if="message !== ''" class="text-center">{{message}}</p>
                  <!-- "Submit" button -->
                  <div class="d-flex justify-content-center">
                    <BootstrapButton type="submit" class="btn-cta">
                      {{ $t('modules.Newsletter.sign-up') }}
                    </BootstrapButton>
                  </div>
                </div>
              </form>
              <!-- END | Form -->

            </div>
          </div>
        </div>
      </div>
    </section>
  `
})
export class NewsletterModuleUi extends AbstractModuleUi<NewsletterModule> {
  /**
   * Message to display
   */
  public message: string = ''

  /**
   * Data entered by the User.
   */
  public formData: NewsletterFormData = {
    email: '',
    newsletter: null
  }

  public welcomeConfig: WelcomeFormConfig = {}

  public get newsletterText (): string {
    return this.welcomeConfig.newsletter || this.$t('components.WelcomeForm.newsletter') as string
  }

  public submitForm (): void {
    this.onSubmit(this.formData).then(() => {
      this.message = String(this.$t('modules.Newsletter.onSuccess'))
    }).catch(() => {
      this.message = String(this.$t('modules.Newsletter.onError'))
    }).finally(() => {
      this.formData = {
        email: null,
        newsletter: null
      }
    })
  }

  public onSubmit (formData: NewsletterFormData): Promise<void> {
    return Promise.resolve()
  }
}
